import { ScoreDailyAverage } from "../../../types/scores";
import { ETrendChartState } from "../types";

export const getCurrentTrendGraph = (data: ScoreDailyAverage[]) => {
  const validValues = data
    .filter((item: ScoreDailyAverage) => item?.visibility !== null)
    .map((item: ScoreDailyAverage) => item.visibility);

  if (validValues.length === 1) return ETrendChartState.Up;
  if (validValues.length <= 1) return ETrendChartState.Neutral;

  const lastValue = validValues[validValues.length - 1];
  const penultimateValue = validValues[validValues.length - 2];

  if (lastValue === penultimateValue) return ETrendChartState.Neutral;

  return lastValue > penultimateValue ? ETrendChartState.Up : ETrendChartState.Down;
};
